import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Login from '../views/login';
import AdminRoutes from './protectedRouter';
// import NavBar from '../components/navbar/navbar';
import DashboardAdmin from './adminRouter';
import 'react-toastify/dist/ReactToastify.css';

export const unisAdminRoutes = {
  MAIN: '/',
  ADMINPATCH: '/management/',
};

export default function AppRouter() {
  // const { claim } = useSelector((state) => state.auth);
  return (
    <>
      <ToastContainer />
      {/* {claim === 'adminUser' ? null : <NavBar />} */}
      <Switch>
        <Route exact path={unisAdminRoutes.MAIN} component={Login} />
        <AdminRoutes path={unisAdminRoutes.ADMINPATCH} component={DashboardAdmin} />
        <Redirect to={unisAdminRoutes.MAIN} />
      </Switch>
    </>
  );
}
